// Code common to all site pages lives here

/* global jQuery */

const $             = jQuery;   // jQuery loaded via WordPress enqueue process
// const dc            = require('./utilities/device-check');
const header        = require('./components/header');
// const lity          = require('lity');
const greebles		= require('./components/greebles');
const anims			= require('./components/anims');

function initHeader() {
	// console.log("initHeader()");
    let $header = $('.site-header');
    if ($header.length) {
        header.init($header);
    }
}

// function initBlockHoverOnMobile() {
// 	function hasTouch() {
// 		console.log('initBlockHoverOnMobile: hasTouch()');
// 		return 'ontouchstart' in document.documentElement
// 			|| navigator.maxTouchPoints > 0
// 			|| navigator.msMaxTouchPoints > 0;
// 	}

// 	if (hasTouch()) { // remove all the :hover stylesheets — https://stackoverflow.com/a/30303898
// 		try { // prevent exception on browsers not supporting DOM styleSheets properly
// 			for (var si in document.styleSheets) {
// 				var styleSheet = document.styleSheets[si];
// 				if (!styleSheet.cssRules) continue;

// 				for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
// 					if (!styleSheet.cssRules[ri].selectorText) continue;

// 					if ((styleSheet.cssRules[ri].selectorText.match(':hover')) || 
// 					(styleSheet.cssRules[ri].selectorText.match(':hover img'))) {
// 						console.log('initBlockHoverOnMobile: HOVER REMOVED: '+styleSheet.href);
// 						console.log('initBlockHoverOnMobile: HOVER REMOVED: '+styleSheet.cssRules[ri].selectorText);
// 						styleSheet.deleteRule(ri);
// 					}
// 				}
// 			}
// 		} catch (ex) {}
// 	}
// }

exports.init = function() {
    // Do common initialization...
    initHeader();
	// initBlockHoverOnMobile();
	initModule(anims);
	initModule(greebles);
};

function initModule(mod) {
	// console.log("initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}